import TitleListState from "@/modules/title-list";
import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";

export const RWTextAnalysisResolver = async function (to: Route, from: Route, next: Function) {
	// fetch all units (levels) and language skills
	const titleListModule = getModule(TitleListState);
	const actions: Promise<void>[] = [];
	if (!titleListModule.languageSkills.length) {
		actions.push(titleListModule.fetchLanguageSkills());
	}
	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}
	await Promise.all(actions);
	next();
};
